// Base paths
const domain_GET = process.env.REACT_APP_DOMIN_PHP_API_GET;
const domain_WRITE = process.env.REACT_APP_DOMIN_PHP_API;
const version = process.env.REACT_APP_VERSION_API;
const endpoint = process.env.REACT_APP_ENDPOINT_API;
const prefix = process.env.REACT_APP_PREFIX_API;

// Main paths
const BaseUrl = `${domain_WRITE}/${prefix}/${version}`;

const InterviewURL = `${domain_GET}/${endpoint}/schedule/${version}/interview`;

/**
 * Constructed paths object
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // Common URLs, to perform various requests
    common: {
        media: `${BaseUrl}/media`,
        // Authenticated proxy used to fetch stored files, it must always be
        // requested through axios so the Authorization header is attached.
        download: `${domain_GET}/${prefix}/download`,
    },

    /**
   * Overview URLs
   */
    overview: {
        interviews: `${InterviewURL}`,
    },

};
